import { config } from "../env";
import { patch } from "./helpers/http-handler";

export const updateComment = (id: string, payload: { comments: string }) =>
  patch(`${config.API_URL}/comments/${id}`, payload);
